import React, { useState, useEffect } from 'react';

const Footer = () => {


    return (
        <div className="text-center">
            <strong><a href="" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>Show time</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>INOVACT SARL</a>
        </div>
    );
};

export default Footer;